export const FETCH_TIMELINE_REPORT_REQUEST = 'FETCH_TIMELINE_REPORT_REQUEST';
export const FETCH_TIMELINE_REPORT_SUCCESS = 'FETCH_TIMELINE_REPORT_SUCCESS';
export const FETCH_TIMELINE_REPORT_FAILURE = 'FETCH_TIMELINE_REPORT_FAILURE';


